import { render, staticRenderFns } from "./HubDetail.vue?vue&type=template&id=891fa6c0&scoped=true"
import script from "./HubDetail.vue?vue&type=script&lang=js"
export * from "./HubDetail.vue?vue&type=script&lang=js"
import style0 from "./HubDetail.vue?vue&type=style&index=0&id=891fa6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891fa6c0",
  null
  
)

export default component.exports